export default __webpack_public_path__ + "static/media/push12.bba160cf.gif";